import { createApiHooks } from '@apis/next/common';
import { Meta, PatchMeta, PdfMeta } from '@models/next/Meta';

export const metaApis = createApiHooks('', [
  {
    method: 'get',
    path: '/meta',
    response: Meta,
  },
  {
    method: 'get',
    path: '/pdf/meta',
    response: PdfMeta,
  },
  {
    method: 'patch',
    path: '/dashboard/meta',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PatchMeta,
      },
    ],
    response: PatchMeta,
  },
]);
